export default __webpack_public_path__ + "static/1-1 v3-5099d5b71ed4bd9908a6456d607e9dc7.mp4";